<template>
  <SendProjectApprovalModal
    v-if="showSendProjectApprovalModal"
    :projectId="projectId"
    @closeModal="closeModal"
  />
  <EvaluationProjectModal
    v-if="showEvaluationProjectModal"
    :projectId="projectId"
    @closeModal="closeEvaluationProjectModal"
  />
  <ResendProjectApprovalModal
    v-if="showResendProjectApprovalModal"
    :projectId="projectId"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Comitê</h6>
      <div class="ms-auto">
        <button
          v-if="isCollaboratorPrincipalProject && canSendProjectApproval"
          type="button"
          class="btn btn-sm btn-success"
          title="Enviar Sumário Executivo para Aprovação do Comitê"
          @click="showSendProjectApprovalModal = true"
        >
          Enviar para Comitê
        </button>
        <button
          v-if="waitingForApproval && getProfileById(profileAprovador)"
          type="button"
          class="btn btn-sm btn-success"
          title="Avaliar Sumário Executivo"
          @click="showEvaluationProjectModal = true"
        >
          Avaliar
        </button>
        <button
          v-if="isCollaboratorPrincipalProject && canResendProjectApproval"
          type="button"
          class="btn btn-sm btn-success"
          title="Reenviar Sumário Executivo para Aprovação do Comitê"
          @click="showResendProjectApprovalModal = true"
        >
          Reenviar para Comitê
        </button>
      </div>
    </div>
    <div class="card-body">
      <div
        v-if="
          isCollaboratorPrincipalProject &&
          (canSendProjectApproval || canResendProjectApproval)
        "
        class="text-center"
      >
        <strong>
          Antes de enviar o sumário executivo para o comitê, por favor, revise
          todos os dados preenchidos!
        </strong>
      </div>
      <div v-if="waitingForApproval" class="text-center">
        O sumário executivo está aguardando aprovação do comitê
      </div>
    </div>
    <div v-if="approvals.length > 0">
      <hr class="my-2" />
      <div class="table-responsive">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>Usuário</th>
              <th class="text-center">Status</th>
              <th class="text-center">Data</th>
              <th>Observações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="approval in approvals" :key="approval.id">
              <td>{{ approval.name }}</td>
              <td
                class="text-center"
                v-html="statusApprovalProjectTranslate(approval.status)"
              />
              <td class="text-center">
                {{ dateTimeSqlToDateTimeBR(approval.date) }}
              </td>
              <td>{{ approval.observation }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SendProjectApprovalModal from '@/components/projects/committee/SendProjectApprovalModal.vue'
import EvaluationProjectModal from '@/components/projects/committee/EvaluationProjectModal.vue'
import ResendProjectApprovalModal from '@/components/projects/committee/ResendProjectApprovalModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'
import { statusApprovalProjectTranslate } from '@/utils/strings'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import StatusProjectEnum from '@/enum/statusProjectEnum'
import ProfileEnum from '@/enum/profileEnum'

export default {
  name: 'CommitteeProject',

  components: {
    SendProjectApprovalModal,
    EvaluationProjectModal,
    ResendProjectApprovalModal,
    LoadingData,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showSendProjectApprovalModal: false,
      showEvaluationProjectModal: false,
      showResendProjectApprovalModal: false,
      approvals: [],
      statusApprovalProjectTranslate,
      dateTimeSqlToDateTimeBR,
    }
  },

  computed: {
    ...mapGetters([
      'projectSelected',
      'isCollaboratorPrincipalProject',
      'getProfileById',
    ]),

    canSendProjectApproval() {
      return this.projectSelected.status === StatusProjectEnum.EM_CADASTRO
    },

    waitingForApproval() {
      return (
        this.projectSelected.status === StatusProjectEnum.AGUARDANDO_APROVACAO
      )
    },

    canResendProjectApproval() {
      return (
        this.projectSelected.status === StatusProjectEnum.REPROVADO_COM_AJUSTES
      )
    },

    profileAprovador() {
      return ProfileEnum.APROVADOR
    },
  },

  methods: {
    async getApprovals() {
      try {
        this.approvals = await this.$store.dispatch(
          'getProjectApprovals',
          this.projectId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getProject() {
      try {
        await this.$store.dispatch('getProject', this.projectId)
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeModal(loadData) {
      if (loadData) {
        this.getProject()
        this.getApprovals()
      }
      this.showSendProjectApprovalModal = false
      this.showResendProjectApprovalModal = false
    },

    closeEvaluationProjectModal(redirect) {
      this.showEvaluationProjectModal = false
      if (redirect) {
        this.$router.push({
          name: 'Projects',
        })
      }
    },
  },

  mounted() {
    this.getApprovals()
  },
}
</script>
